export default {
  header: {
    projectName: 'Nama Proyek',
    export: 'Ekspor',
    debug: 'Debug',
    success: 'Berhasil',
    failed: 'Gagal',
    generating: 'Membuat video...',
    updateNameFailed: 'Gagal memperbarui nama proyek',
    menu: 'Menu',
    settings: 'Pengaturan',
    shortcuts: 'Pintasan Keyboard',
    about: 'Tentang',
    darkMode: 'Mode Gelap',
    lightMode: 'Mode Terang',
    settingsComingSoon: 'Fitur pengaturan segera hadir',
    shortcutsComingSoon: 'Fitur pintasan keyboard segera hadir',
    aboutComingSoon: 'Informasi tentang segera hadir',
    language: 'Bahasa',
    dimensions: 'Dimensi',
    canvas: 'Kanvas',
    view: 'Tampilan',
    general: 'Umum'
  },
  menu: {
    media: 'Media',
    text: 'Teks'
  },
  loading: {
    core: 'Memuat Inti...'
  },
  home: {
    title: 'GeminiXiang Studio',
    version: 'Beta Publik',
    betaDisclaimer: 'Versi beta, persistensi data tidak dijamin',
    newProject: 'Proyek Baru',
    backupFolder: 'Folder Cadangan',
    documentation: 'Dokumentasi',
    recentProjects: 'Proyek Terbaru',
    viewAll: 'Lihat semua ({count})',
    noProjects: 'Belum ada proyek. Buat proyek pertama Anda untuk memulai!',
    login: 'MASUK',
    github: 'GITHUB',
    discord: 'DISCORD',
    blog: 'BLOG',
    projectCreated: 'Proyek Dibuat',
    projectCreatedDesc: 'Proyek baru berhasil dibuat',
    projectDeleted: 'Proyek Dihapus',
    projectDeletedDesc: 'Proyek berhasil dihapus',
    deleteConfirmation: 'Apakah Anda yakin ingin menghapus proyek ini? Tindakan ini tidak dapat dibatalkan.',
    migrationFailed: 'Migrasi Gagal',
    migrationFailedDesc: 'Gagal memigrasi data dari localStorage',
    loadFailed: 'Gagal Memuat',
    loadFailedDesc: 'Gagal memuat proyek',
    creationFailed: 'Gagal Membuat',
    creationFailedDesc: 'Gagal membuat proyek baru',
    deletionFailed: 'Gagal Menghapus',
    deletionFailedDesc: 'Gagal menghapus proyek'
  },
  timeline: {
    autoSaveFailed: 'Gagal menyimpan otomatis',
    autoSaveFailedDesc: 'Gagal menyimpan otomatis proyek',
    loadFailed: 'Gagal Memuat',
    loadFailedDesc: 'Gagal memuat proyek. Mengalihkan ke beranda...',
    mainTrack: 'Trek Utama',
    undo: 'Urungkan',
    redo: 'Ulangi',
    split: 'Pisah',
    delete: 'Hapus'
  },
  attributes: {
    properties: 'Properti',
    position: 'Posisi',
    scale: 'Skala',
    animation: 'Animasi',
    basic: 'Dasar',
    mute: 'Bisukan',
    text: 'Teks',
    fontSize: 'Ukuran Font',
    content: 'Konten',
    fontFamily: 'Keluarga Font',
    direction: 'Arah Teks',
    color: 'Warna',
    stroke: 'Garis Tepi',
    background: 'Latar Belakang',
    video: 'Video',
    rotate: 'Putar',
    backgroundColor: 'Warna Latar',
    opacity: 'Opasitas',
    blend: 'Campuran',
    filter: 'Filter',
    effect: 'Efek',
    transition: 'Transisi',
    speed: 'Kecepatan',
    volume: 'Volume'
  },
  router: {
    editor: 'Editor Video',
    preview: 'Pratinjau',
    storyboard: 'Papan Cerita - Agen Video AI'
  },
  placeholder: {
    text: 'Silakan masukkan konten teks',
    input: 'Silakan masukkan'
  },
  error: {
    parseAudio: 'Gagal mengurai audio',
    parseImage: 'Gagal mengurai gambar',
    parseVideo: 'Gagal mengurai video',
    noProject: 'Silakan buat atau buka proyek terlebih dahulu',
    invalidFileType: 'Jenis file tidak valid'
  },
  media: {
    video: 'Video',
    image: 'Gambar',
    audio: 'Audio',
    dropToUpload: 'Tarik file ke sini untuk mengunggah'
  },
  common: {
    defaultText: 'Teks Default',
    delete: 'Hapus'
  }
};
